import { defineMessages } from "react-intl";

const messages = defineMessages({
    enterKey: {
        id: "homework.progress.key",
    },
    unknown: {
        id: "general.unknown",
    },
    enterName: {
        id: "join.enterName",
    },
    name: {
        id: "join.name",
    },
    submitName: {
        id: "join.enterName.submit",
    },
    turnDevice: {
        id: "join.turnDevice",
    },
    toFullScreen: {
        id: "join.toFullScreen",
    },
    fullScreenButton: {
        id: "join.toFullScreen.button",
    },
    join: {
        id: "classroom",
    },
    privacyNote: {
        id: "homework.privacyNote",
    },
    privacy: {
        id: "privacy.title",
    },
    privacyDuration: {
        id: "connect.privacyDuration"
    },
    classroom: {
        id: "classroom",
    }
});

export default messages;
